import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import './styles/Careers.css';

const Careers = () => {
  const [careers, setCareers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    resume: null
  });

  useEffect(() => {
    const fetchCareers = async () => {
      try {
        const response = await axios.get(`${API_URL}/careers`);
        setCareers(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load career opportunities');
        setLoading(false);
      }
    };

    fetchCareers();
  }, []);

  const handleResumeUpload = async (e, jobTitle) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (!file) return;

    // Check file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('File size should not exceed 5MB');
      return;
    }

    setFormData({ ...formData, resume: file });
    setSelectedJob(jobTitle);
  };

  const handleSubmit = async (jobTitle) => {
    try {
      if (!formData.name.trim()) {
        alert('Please enter your name');
        return;
      }

      if (!formData.email.trim()) {
        alert('Please enter your email');
        return;
      }

      if (!formData.resume) {
        alert('Please select a resume file');
        return;
      }

      const submitFormData = new FormData();
      submitFormData.append('resume', formData.resume);
      submitFormData.append('jobTitle', jobTitle);
      submitFormData.append('name', formData.name);
      submitFormData.append('email', formData.email);

      console.log('Submitting application...', {
        jobTitle,
        name: formData.name,
        email: formData.email,
        resumeName: formData.resume.name
      });

      const response = await axios.post(`${API_URL}/careers/apply`, submitFormData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.log('Server response:', response.data);
      alert('Resume submitted successfully!');
      setFormData({ name: '', email: '', resume: null });
      setSelectedJob(null);
    } catch (error) {
      console.error('Upload error:', error.response?.data || error);
      alert(
        error.response?.data?.message || 
        error.response?.data?.error || 
        error.message || 
        'Failed to submit resume. Please try again.'
      );
    }
  };

  if (loading) return <div className="loading-text">Loading...</div>;
  if (error) return <div className="error-text">{error}</div>;

  return (
    <div className="careers-container">
      <h1 className="careers-title">Career Opportunities</h1>
      <div className="careers-list">
        {careers.map((career) => (
          <div key={career._id} className="career-card">
            <h2 className="career-title">{career.title}</h2>
            <p className="career-description">{career.description}</p>
            
            {selectedJob === career.title ? (
              <div className="application-form">
                <input
                  type="text"
                  placeholder="Your Name"
                  className="form-input"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
                <input
                  type="email"
                  placeholder="Your Email"
                  className="form-input"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                />
                <label className="upload-resume">
                  {formData.resume ? `Selected: ${formData.resume.name}` : 'Upload Resume'}
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => handleResumeUpload(e, career.title)}
                    style={{ display: 'none' }}
                  />
                </label>
                <button 
                  className="submit-button"
                  onClick={() => handleSubmit(career.title)}
                >
                  Submit Application
                </button>
              </div>
            ) : (
              <button 
                className="upload-resume"
                onClick={() => setSelectedJob(career.title)}
              >
                Apply Now
              </button>
            )}
          </div>
        ))}
        {careers.length === 0 && (
          <div className="no-careers">
            No career opportunities available at the moment.
          </div>
        )}
      </div>
    </div>
  );
};

export default Careers;
